import { UpdateUserRole, InviteUser, SharePointConfig, EligibilityConfig } from "admin/components";
import "./UserAdmin.scss";
import { Card, Tabs, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

export const UserAdmin = () => {
  return (
    <Card className='user-admin-container'>
      <Title level={1}>Admin Settings</Title>
      <Tabs
        defaultActiveKey='users'
        items={[
          {
            key: "users",
            label: "User Management",
            children: (
              <>
                <Title className="user-management-header">User Management</Title>
                <Paragraph>
                  Tenant roles control what users can access across all organizations within this tenant.
                  Roles are listed below in order from highest to lowest access:
                </Paragraph>
                <ul>
                  <li><Text strong>Owner</Text> — Full tenant access, including billing and all admin settings</li>
                  <li><Text strong>Admin</Text> — Manage users, organizations, and tenant-level settings</li>
                  <li><Text strong>Viewer</Text> — Read-only access across the tenant</li>
                </ul>
                <InviteUser />
                <UpdateUserRole />
              </>
            ),
          },
          {
            key: "integrations",
            label: "Integrations",
            children: (
              <>
                <SharePointConfig />
                <EligibilityConfig />
              </>
            ),
          },
        ]}
      />
    </Card>
  );
};
